'use client';

import { useEffect, useRef, useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const stats = [
{ n: '12 500+', l: 'Commandes livrées', icon: '📦' },
{ n: '4.9/5', l: 'Note clients', icon: '⭐' },
{ n: '98%', l: 'Clients satisfaits', icon: '✅' },
{ n: '< 1h', l: 'Délai moyen', icon: '⚡' }];


const testimonials = [
{
  id: 'test-1',
  name: 'Aya Coulibaly',
  role: 'Entrepreneuse, Abidjan',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1cefb4549-1772985337555.png",
  avatarAlt: 'Femme ivoirienne souriante en tenue professionnelle',
  text: 'J\'ai commandé 1 000 abonnés pour ma page boutique. Livré en moins de 6h ! Mon engagement a triplé en une semaine. Je recommande SocialBoost à toutes les entrepreneures.',
  stars: 5,
  service: 'Abonnés Facebook',
  date: 'Février 2026'
},
{
  id: 'test-2',
  name: 'Moussa Traoré',
  role: 'Influenceur, Bouaké',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_131711f63-1767020629895.png",
  avatarAlt: 'Homme africain souriant avec téléphone portable',
  text: 'Super service ! J\'ai pris les likes pour mes publications et j\'ai vu ma portée exploser. Le paiement via Orange Money était super pratique. Je suis client fidèle maintenant.',
  stars: 5,
  service: 'Likes & Réactions',
  date: 'Janvier 2026'
},
{
  id: 'test-3',
  name: 'Fatou Diallo',
  role: 'Coach, San-Pédro',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1801641af-1763301272277.png",
  avatarAlt: 'Femme africaine professionnelle avec sourire confiant',
  text: 'Les commentaires en français sont vraiment naturels. Mes posts semblent très populaires maintenant. Excellent rapport qualité-prix, et le support WhatsApp est très réactif.',
  stars: 5,
  service: 'Commentaires',
  date: 'Mars 2026'
}];


export default function Testimonials() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [activeIdx, setActiveIdx] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.stat-reveal').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 sm:py-28 px-4 sm:px-6" style={{ background: '#F4F6FB' }}>
      <div className="max-w-7xl mx-auto">
        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          {stats.map((s) =>
          <div
            key={s.l}
            className="stat-reveal bg-white rounded-2xl p-6 text-center shadow-card border border-[rgba(13,27,62,0.05)]"
            style={{ opacity: 0, transform: 'translateY(20px)', transition: 'all 0.6s cubic-bezier(0.16,1,0.3,1)' }}>
            
              <div className="text-3xl mb-2">{s.icon}</div>
              <div className="stat-number">{s.n}</div>
              <div className="text-[#6B7280] text-xs mt-1 font-medium">{s.l}</div>
            </div>
          )}
        </div>

        {/* Testimonials header */}
        <div className="text-center mb-10">
          <div className="section-label mb-5 mx-auto" style={{ display: 'inline-flex' }}>
            <Icon name="ChatBubbleLeftRightIcon" size={13} className="text-[#1877F2]" />
            Avis clients
          </div>
          <h2 className="font-heading font-bold text-[#0D1B3E]" style={{ fontSize: 'clamp(1.8rem,4vw,3rem)', lineHeight: 1.15 }}>
            Ce que disent nos{' '}
            <span className="gradient-text">clients ivoiriens</span>
          </h2>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) =>
          <div
            key={t.id}
            className="bg-white rounded-3xl p-7 shadow-card border border-[rgba(13,27,62,0.05)] flex flex-col gap-4 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(13,27,62,0.1)]"
            onClick={() => setActiveIdx(i)}
            style={{ borderColor: activeIdx === i ? 'rgba(24,119,242,0.3)' : 'rgba(13,27,62,0.05)' }}>
            
              {/* Stars */}
              <div className="flex gap-1">
                {Array.from({ length: t.stars }).map((_, j) =>
              <span key={j} className="text-[#F4A923] text-sm">★</span>
              )}
              </div>

              {/* Quote */}
              <p className="text-[#374151] text-sm leading-relaxed flex-1">"{t.text}"</p>

              {/* Service badge */}
              <span
              className="self-start text-xs font-semibold px-3 py-1 rounded-full"
              style={{ background: 'rgba(24,119,242,0.08)', color: '#1877F2', border: '1px solid rgba(24,119,242,0.15)' }}>
              
                {t.service}
              </span>

              {/* Author */}
              <div className="flex items-center gap-3 pt-2 border-t border-[rgba(13,27,62,0.06)]">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <AppImage
                  src={t.avatar}
                  alt={t.avatarAlt}
                  width={40}
                  height={40}
                  className="w-full h-full object-cover" />
                
                </div>
                <div>
                  <div className="font-semibold text-[#0D1B3E] text-sm">{t.name}</div>
                  <div className="text-[#9CA3AF] text-xs">{t.role} · {t.date}</div>
                </div>
                <span className="ml-auto text-lg">🇨🇮</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}